import { createSlice } from '@reduxjs/toolkit';
import { ITableFiltersParams } from 'core/models/general.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';

export interface IState {
  count: number
  isLoading: boolean
  error: object | null
  params: ITableFiltersParams
  results: IBookingDataItem[]
}

const initialState: IState = {
  count: 0,
  results: [],
  error: null,
  params: {},
  isLoading: true,
};

const BookingReportDataSlice = createSlice({
  name: 'getBookingReportData',
  initialState,
  reducers: {
    getBookingReportDataRequest: (state, action) => ({
      ...state,
      isLoading: true,
      params: action.payload,
    }),
    getBookingReportDataSuccess: (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
    }),
    getBookingReportDataFailure: (state, action) => ({
      ...state,
      results: [],
      isLoading: false,
      error: action.payload,
    }),
    clearBookingReportDataAction: () => initialState,
  },
});

export const {
  getBookingReportDataRequest,
  getBookingReportDataSuccess,
  getBookingReportDataFailure,
  clearBookingReportDataAction,
} = BookingReportDataSlice.actions;

export const getBookingReportDataReducer = BookingReportDataSlice.reducer;
